<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" size="mini" @click="dialogVisible = true">转账</el-button>
    <el-dialog :visible="dialogVisible" title="发起转账" width="500px" @close="closeDialog">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="内部转账" name="first"></el-tab-pane>
        <el-tab-pane label="模拟盘" name="second"></el-tab-pane>
      </el-tabs> -->
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
        <!-- <el-form-item label="用户类型：" prop="coinType">
          <el-select v-model="userType" placeholder="请选择">
            <el-option
              v-for="item in lists"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="用户账号："
          prop="toUser"
          v-if="this.userType == 1"
        >
          <el-input v-model="detail.userId"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="用户ID：" prop="userId" v-if="this.userType == 2">
          <el-input v-model="detail.userId"></el-input>
        </el-form-item> -->
        <el-form-item label="用户ID：" prop="userId">
          <el-input-number :controls="false" v-model="detail.userId"></el-input-number>
        </el-form-item>
        <el-form-item label="币种：" prop="coin">
          <el-select v-model="detail.coin" placeholder="请选择">
            <el-option v-for="item in coinTypes" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账类型：" prop="type">
          <el-select v-model="detail.type" placeholder="请选择">
            <el-option v-for="item in transferTypeData" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额：" prop="amount">
          <el-input-number v-model="detail.amount" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">确定转账</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "PledgeCreate",
  data() {
    return {
      dialogVisible: false,
      activeName: "first",
      detail: {
        type: "",
      },
      userType: "1",
      lists: [
        { label: "用户账号", value: "1" },
        { label: "用户ID", value: "2" },
      ],
      coinTypes: ["USDT"],
      // coinTypes: ["USDT", "SHIB", "BABYDOGE", "ETH"],
      rules: {
        userId: {
          required: true,
          message: "请填写转入的用户账号",
          trigger: "blur",
        },
        coin: {
          required: true,
          message: "请选择币种",
          trigger: "blur",
        },
        amount: {
          required: true,
          message: "请输入转账金额",
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    activeName: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.detail = {};
          this.$refs["form"].resetFields();
        }
      },
    },
  },
  computed: {
    ...mapState("transferInnerMock", ["transferTypeData"]),
  },
  mounted() {
    this.getTransferType();
  },
  methods: {
    ...mapActions("transferInnerMock", [
      "create",
      "transfer",
      "mockTransfer",
      "reqList",
      "getTransferType",
    ]),
    handleClick(tab, event) {
      console.log(tab.name, event);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.activeName = 'first'
      this.$refs["form"].resetFields();
    },
    close() {
      this.dialogVisible = false;
      this.detail = {};
      this.activeName = 'first'
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const res = await this.mockTransfer({ ...this.detail });
          if (res.code == 0) {
            this.$message({
              message: "转账成功！",
              type: "success",
            });
            this.$emit("refresh", { page: 1 });
            this.dialogVisible = false;
          }
          // if (this.activeName == "first") {
          //   console.log("内部");
          //   const res = await this.transfer({ ...this.detail });
          //   if (res.code == 0) {
          //     this.$message({
          //       message: "转账成功！",
          //       type: "success",
          //     });
          //     this.$emit("refresh", { page: 1 });
          //     this.dialogVisible = false;
          //   }
          // } else {
          //   console.log("模拟盘");
          //   const res = await this.mockTransfer({ ...this.detail });
          //   if (res.code == 0) {
          //     this.$message({
          //       message: "转账成功！",
          //       type: "success",
          //     });
          //     this.$emit("refresh", { page: 1 });
          //     this.dialogVisible = false;
          //   }
          // }
        }
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
